import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/auth';
import {Link} from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },

  maintoolbar: {
    background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)'
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  menuitem: {
    textDecoration: 'none',
    color: '#303030'
  },

  exitbutton: {
    float: 'right'
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  accountMenu: {
    color: "white",
    marginLeft: theme.spacing(2),
  },
  menuContainer: {
    float: "right",
    marginLeft: "auto",
  }

}));



function AppBarMenu({signOutUser}) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const clickOut = () => {
      signOutUser()
    }




    const handleClick = event => {
    setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };


    return (
      <>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar
            className={classes.maintoolbar}
          >

            <Link
              to = {'/'}
              className={classes.menuitem}>
              <Typography variant="h6" noWrap style={{color: 'white'}}>
                Marketing Tools App
              </Typography>
            </Link>
            <div className={classes.menuContainer}>
            <Button className={classes.accountMenu}>
              <Link to = {'/project'} style={{ textDecoration: "none", color: "white"}}>
                  Projects
              </Link>
            </Button>
            <Button className={classes.accountMenu}>
              <Link to = {'/contacts'} style={{ textDecoration: "none", color: "white"}}>
                  Contacts
              </Link>
            </Button>

            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
              className={classes.accountMenu}

              >
              Account
            </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>My account</MenuItem>
                <MenuItem onClick={() => clickOut()}>
                  <ExitToAppIcon/>
                  Logout
                </MenuItem>
              </Menu>
            </div>


          </Toolbar>
        </AppBar>
      </>
    );
}

const mapStateToProps = state => state.project;

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(AppBarMenu)
